import "./fragments"

import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetTransferWarehouse($input: WarehouseAreaGetInput!) {
    warehouseArea {
      get(input: $input) {
        ... on WarehouseAreaGetSuccess {
          warehouseArea {
            ...WarehouseAreaBaseFields
          }
        }
        ... on WarehouseAreaGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetTransferList($input: TransferListInput!) {
    transfer {
      list(input: $input) {
        ... on TransferListSuccess {
          items {
            ...TransferFields
          }
          pageInfo {
            total
            offset
            limit
          }
        }
        ... on TransferListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetTransfer($input: TransferGetByIdInput!) {
    transfer {
      getById(input: $input) {
        ... on TransferGetSuccess {
          transfer {
            ...TransferFields
          }
        }
        ... on TransferGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetTransferProductInventoryList($input: InventoryByProductListInput) {
    inventory {
      listByProduct(input: $input) {
        ... on InventoryByProductListSuccess {
          items {
            product {
              productId
              publicId
              externalSystemId
              computedProductStatus
              versionId
              versions {
                id
                versionNumber
                releaseDate
                status
              }
              companyProductDescription
              vendorDescription
              packageUsWeightUom
              packageUsWeightUomDetails {
                name
              }
              company {
                companyId
                name
              }
            }
            qtyOnHand
            warehouses {
              warehouseId
              qtyOnHand
              numPallets
            }
          }
        }
        ... on InventoryByProductListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
